import {Fragment, useEffect, useState} from 'react';

import {InvoiceService} from '../../hoa-don/InvoiceService';
import {RegisterInvoiceService} from '../../../service/invoice/RegisterInvoiceService';
import {CurrencyService} from '../../danh-muc/tien-te/CurrencyService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';

import {DialogCrup} from '../../hoa-don/component/DialogCrup';
import {DialogSelectInvoice} from '../../hoa-don/component/DialogSelectInvoice';
import {DialogView} from '../../hoa-don/component/DialogView';

import {DialogStatement} from '../components/DialogStatement';
import {DialogAttachment} from '../components/DialogAttachment';
import {useSign} from '../../../shared/component/Sign';

export const List = () => {

  const header = 'Hoá đơn điều chỉnh';
  const dataKey = 'invoiceId';

  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(null);

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [displayCrup, setDisplayCrup] = useState(false);
  const [registerInvoice, setRegisterInvoice] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [currencies, setCurrencies] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState(null);

  const [displayStatement, setDisplayStatement] = useState(false);
  const [displayUpload, setDisplayUpload] = useState(false);
  const [displayView, setDisplayView] = useState(false);
  const [documentType, setDocumentType] = useState(InvoiceService.documentType_Adjust);

  useEffect(() => {
    RegisterInvoiceService.getUsingList({maxResultCount: 1000}).then(({items}) => {
      const _registerInvoices = [];
      items.forEach(item => {
        item.label = `${item.symbolCode} - ${item.invoiceTypeName}`;
        _registerInvoices.push(item);
      });
      setRegisterInvoices(_registerInvoices);
      setRegisterInvoice(_registerInvoices[0]);
    });
    CurrencyService.getList({}).then(({items}) => {
      setCurrencies(items);
    });
    InvoiceService.getPaymentTypes().then(({items}) => {
      const _paymentTypes = [];
      items.forEach(item => {
        _paymentTypes.push({value: item.name, label: item.name});
      });
      setPaymentTypes(_paymentTypes);
    });
  }, []);

  const {render: renderDataTable, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    headerColumnGroups: [
      {header: 'Hoá đơn điều chỉnh', colSpan: 8},
      {header: 'Hoá đơn bị điều chỉnh', colSpan: 4}
    ],
    columns: [
      {field: 'invoiceSerial', header: 'Ký hiệu', width: 100, matchMode: 'contains'},
      {field: 'invoiceNumber', header: 'Số hoá đơn', width: 110, matchMode: 'contains'},
      {field: 'invoiceDate', header: 'Ngày hoá đơn', width: 120, dataType: 'date'},
      {
        field: 'sendTaxStatus', header: 'Trạng thái gửi CQT', width: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: InvoiceService.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
          if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
            return <span className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
          }
          return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
        }
      },
      {
        field: 'buyerLegalName', header: 'Khách hàng', minWidth: 200, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      {
        field: '', header: 'Biên bản', width: 110, sortable: false, dataType: 'custom', customCell(rowData): any {
          const text = rowData.hasDocument ? 'Đã lập biên bản' : 'Lập biên bản';
          return (
            <span className="underline text-primary" onClick={() => setDisplayStatement(true)}>{text}</span>
          );
        }, style: {justifyContent: 'center'}
      },
      {
        field: '', header: 'Thao tác', width: 100, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <div className='flex gap-3'>
              <i className="pi pi-link " title="File dính kèm" onClick={() => setDisplayUpload(true)}></i>
              <i className="pi pi-eye " title="Xem hoá đơn" onClick={() => viewInvoice(rowData)}></i>
            </div>
          );
        }, style: {justifyContent: 'center'}
      },
      {field: 'relatedInvoiceSerial', header: 'Ký hiệu', width: 100, matchMode: 'contains'},
      {field: 'relatedInvoiceNumber', header: 'Số hoá đơn', width: 110, matchMode: 'contains'},
      {field: 'relatedInvoiceDate', header: 'Ngày hoá đơn', width: 120, dataType: 'date'},
      {field: 'invoiceNote', header: 'Lý do sai sót', width: 110, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.IsOtherInvoice = false;
      return InvoiceService.getListAdjustments(params);
    },
    selectionMode: 'single'
  });

  const viewInvoice = (rowData) => {
    setSelectedInvoice({
      id: rowData.invoiceId,
      buyerTaxCode: rowData.buyerTaxCode,
      invoiceSerial: rowData.invoiceSerial,
      invoiceNumber: rowData.invoiceNumber
    });
    setDisplayView(true);
  }

  const {renderToolbar} = useToolbar({
    dataKey,
    reloadLazyData,
    otherActions: [
      {
        label: 'Lập hoá đơn điều chỉnh', icon: 'pi pi-fw pi-user-edit', className: 'iam-toolbar', command: () => {
          setDisplaySelectInvoice(true);
        }
      }
    ]
  });

  const onAddSelectedItems = (items) => {
    if (items) {
      setSelectedInvoice(items);
      setDisplayCrup(true);
    }
  }

  const {renderSign, sign} = useSign({onComplete: reloadLazyData});

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}

      {renderSign()}

      <DialogSelectInvoice display={displaySelectInvoice} setDisplay={setDisplaySelectInvoice} addSelectedItems={onAddSelectedItems} selectionMode="radiobutton"
                           invoiceStatus="0,5" sendTaxStatus="2,4"/>

      <DialogCrup display={displayCrup} setDisplay={setDisplayCrup} reloadLazyData={reloadLazyData}
                  registerInvoices={registerInvoices} currencies={currencies} paymentTypes={paymentTypes}
                  registerInvoice={registerInvoice} selectedItem={selectedInvoice} invoiceStatus={2} setInvoiceStatus={0}
                  sign={sign}/>

      <DialogAttachment display={displayUpload} setDisplay={setDisplayUpload} selectedItem={selectedItems}/>

      <DialogStatement display={displayStatement} setDisplay={setDisplayStatement} selectedItem={selectedItems} documentType = {documentType} reloadLazyData={reloadLazyData} title="điều chỉnh"/>

      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedInvoice}/>
    </Fragment>
  )
}
